import axios from "../../utils/axios";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  applicationHealth: "",
  actuatorHealth: "",
  activeMqHealth: "",
  ingestionHealth: {},
  kafkaHealth: "",
  zookeeperHealth: "",
  databaseHealth: "",
  mailServersHealth: "",
  diskHealth: {},
  memoryHealth: {},
  cpuHealth: {},
  threads: {},
  allDrained: false,
  totalLagAllGroups: 0,
};

const healthSlice = createSlice({
  name: "health",
  initialState,
  reducers: {
    setApplicationHealth(state, action) {
      state.applicationHealth = action.payload;
    },
    setActuatorHealth(state, action) {
      state.actuatorHealth = action.payload;
    },
    setActiveMQHealth(state, action) {
      state.activeMqHealth = action.payload;
    },
    setIngestionHealth(state, action) {
      state.ingestionHealth = action.payload;
    },
    setKafkaHealth(state, action) {
      state.kafkaHealth = action.payload;
    },
    setZookeeperHealth(state, action) {
      state.zookeeperHealth = action.payload;
    },
    setDatabaseHealth(state, action) {
      state.databaseHealth = action.payload;
    },
    setMailServersHealth(state, action) {
      state.mailServersHealth = action.payload;
    },
    setDiskHealth(state, action) {
      state.diskHealth = action.payload;
    },
    setMemoryHealth(state, action) {
      state.memoryHealth = action.payload;
    },
    setCpuHealth(state, action) {
      state.cpuHealth = action.payload;
    },
    setThreads(state, action) {
      state.threads = action.payload;
    },
    setAllDrained(state, action) {
      state.allDrained = action.payload;
    },
    setTotalLagAllGroups(state, action) {
      state.totalLagAllGroups = action.payload;
    },
  },
});

export function getSystemHealth() {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    const impersonationToken =
      window.localStorage.getItem("impersonationToken");
    if (!accessToken) return Promise.reject("No access token");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/health/full`,
        {
          headers: {
            Authorization: `Bearer ${
              impersonationToken ? impersonationToken : accessToken
            }`,
          },
        }
      );
      dispatch(
        healthSlice.actions.setApplicationHealth(
          response.data?.application?.status ?? "UNKNOWN"
        )
      );
      dispatch(
        healthSlice.actions.setActuatorHealth(
          response.data?.springActuator?.status ?? "UNKNOWN"
        )
      );
      dispatch(
        healthSlice.actions.setKafkaHealth(
          response.data?.kafka?.status ?? "UNKNOWN"
        )
      );
      dispatch(
        healthSlice.actions.setZookeeperHealth(
          response.data?.zookeeper?.status ?? "UNKNOWN"
        )
      );
      dispatch(
        healthSlice.actions.setDatabaseHealth(
          response.data?.database?.status ?? "UNKNOWN"
        )
      );
      dispatch(
        healthSlice.actions.setMailServersHealth(
          response.data?.mailConfigurations?.status ?? "UNKNOWN"
        )
      );
      dispatch(
        healthSlice.actions.setActiveMQHealth(
          response.data?.activemq ?? "UNKNOWN"
        )
      );
      dispatch(
        healthSlice.actions.setIngestionHealth(response.data?.ingestion ?? {})
      );
      dispatch(healthSlice.actions.setDiskHealth(response.data?.disk));
      dispatch(healthSlice.actions.setCpuHealth(response.data?.cpu));
      dispatch(healthSlice.actions.setMemoryHealth(response.data?.memory));
      dispatch(healthSlice.actions.setThreads(response.data?.threads));
      return Promise.resolve("Health Status retrieved successfully");
    } catch (error) {
      return Promise.reject("Error retrieving system health");
    }
  };
}

export function getKafkaLag() {
  return async (dispatch) => {
    const accessToken = window.localStorage.getItem("accessToken");
    if (!accessToken) return Promise.reject("No access token");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/config/kafka/lag`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      dispatch(
        healthSlice.actions.setAllDrained(response.data.data.allDrained)
      );
      dispatch(
        healthSlice.actions.setTotalLagAllGroups(
          response.data.data.totalLagAllGroups
        )
      );
      return Promise.resolve("Kafka lags retrieved successfully");
    } catch (error) {
      return Promise.reject("Error retrieving system health");
    }
  };
}

export default healthSlice.reducer;
